<template>
  <!-- Overlay -->
  <div v-if="isLoading" class="full-overlay">
    <span class="spinner-border text-light spinner-overlay" role="status" aria-hidden="true"></span>
  </div>
  <div class="row">
    <!-- Customer Details Section -->
    <div class="col-lg-12 col-xl-6 col-xxl-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-head bg-white d-flex align-items-center">
          <i class="flaticon-user-3 text-primary"></i>
          <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15">
            Customer Details (#{{ customerDetails.id }})
          </h5>
        </div>
        <div class="card-body">
          <ul class="list ps-0 mb-0 list-unstyled">
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-user-1"></i>
                Customer Name:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ customerDetails.first_name }} {{ customerDetails.last_name }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-envelope"></i>
                Email:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ customerDetails.email }}
              </span>
            </li>
            <li class="d-flex align-items-center justify-content-between">
              <div
                class="title text-black fs-md-15 fs-lg-16 fw-semibold position-relative"
              >
                <i class="flaticon-calendar"></i>
                Created At:
              </div>
              <span class="d-block text-paragraph fs-md-15 fs-lg-16">
                {{ formatDate(customerDetails.created_at) }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="col-lg-12 col-xl-6 col-xxl-6">
      <div
        class="card mb-25 border-0 rounded-0 bg-white order-details-box letter-spacing"
      >
        <div class="card-body">
          <div class="justify-content-between d-flex mb-15">
            <div class="bg-white d-flex align-items-center">
              <i class="ph ph-address-book text-primary fs-25"></i>
              <h5 class="mb-0 fw-bold text-black ms-10 ms-md-15 fs-16"> Addresses</h5>
            </div>
            <button type="button" class="btn btn-outline-primary btn-sm position-relative" data-bs-toggle="modal" data-bs-target="#addOrUpateAddressModal" v-on:click="addAddressClicked()">Add Address</button>
          </div>
          <ul class="list-group">
            <li class="list-group-item list-group-item-warning fw-medium fs-md-15" v-if="addresses.length == 0">There are no addresses created for the customer.</li>
            <li class="list-group-item fw-medium fs-md-15 d-flex justify-content-between" v-for="address in addresses" :key="address.id">
              <div class="d-flex flex-column">
                <span class="badge text-bg-warning rounded-pill fs-13" v-if="address.id == customerDetails.primary_shipping_address?.data.id">Primary</span>
                <p class="mb-1 fs-md-15 fs-lg-16">{{ address.name }}</p>
                <address class="mb-0">
                  {{ address.address_line_1 }}<br>
                  {{ address.address_line_2 }}<br v-if="address.address_line_2">
                  {{ address.city }}, {{ address.state_or_region }}, {{ address.postal_code }}<br>
                  {{ address.country_code }}
                </address>
              </div>
              <div class="dropdown">
                <button
                  class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition fs-20 no-after text-paragraph"
                  type="button"
                  data-bs-toggle="dropdown"
                  aria-expanded="false"
                >
                  <i class="flaticon-dots"></i>
                </button>
                <ul class="dropdown-menu">
                  <li>
                    <a
                      data-bs-toggle="modal" data-bs-target="#addOrUpateAddressModal"
                      class="dropdown-item d-flex align-items-center"
                      v-on:click="editAddressClicked(address)"
                      ><i
                        class="flaticon-pen lh-1 me-8 position-relative top-1"
                      ></i>
                      Edit
                    </a>
                  </li>
                  <li>
                    <a
                      v-if="address.id != customerDetails.primary_shipping_address?.data.id"
                      data-bs-toggle="modal" data-bs-target="#confirmDeleteModal"
                      class="dropdown-item d-flex align-items-center cursor-pointer"
                      v-on:click="deleteAddressClicked(address)"
                      ><i
                        class="flaticon-delete lh-1 me-8 position-relative top-1"
                      ></i>
                      Delete</a
                    >
                  </li>
                </ul>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Add Or Edit Address Modal -->
  <div class="modal fade" id="addOrUpateAddressModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ updateAddressId ? 'Edit' : 'Add' }} Address</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col-md-12">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Name</label
                >
                <input
                  type="text"
                  name="addressName"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressName"
                />
                <div class="invalid-feedback" id='addressNameError'></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Line 1</label
                >
                <input
                  type="text"
                  name="addressLine1"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressLine1"
                />
                <div class="invalid-feedback" id='addressLine1Error'></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Line 2</label
                >
                <input
                  type="text"
                  name="addressLine2"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressLine2"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >City</label
                >
                <input
                  type="text"
                  name="addressCity"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressCity"
                />
                <div class="invalid-feedback" id='addressCityError'></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >State</label
                >
                <input
                  type="text"
                  name="addressState"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressState"
                />
                <div class="invalid-feedback" id='addressStateError'></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Zip</label
                >
                <input
                  type="text"
                  name="addressZip"
                  class="form-control shadow-none rounded-0 text-black"
                  v-model="newAddressPostalCode"
                />
                <div class="invalid-feedback" id='addressZipError'></div>
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Country</label
                >
                <input
                  type="text"
                  name="addressCountry"
                  class="form-control shadow-none rounded-0 text-black"
                  readonly="true"
                  v-model="newAddressCountryCode"
                />
              </div>
            </div>
            <div class="col-md-6">
              <div class="form-group mb-15 mb-sm-20 mb-md-25">
                <label class="d-block text-black fw-semibold mb-10"
                  >Primary address</label
                >
                <input
                  type="checkbox"
                  class="form-check-input shadow-none"
                  v-model="newAddressPrimary"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" v-on:click="createOrUpdateAddress()" class="btn btn-outline-primary">{{ updateAddressId ? 'Update' : 'Create'}}</button>
        </div>
      </div>
    </div>
  </div>

  <!-- Delete Address Modal -->
  <div class="modal fade" id="confirmDeleteModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">Removing address, once this action is confirmed it cannot be undone. Confirm?</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <div class="row">
            <address>

            </address>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" id="closeCofirmDeleteModal" class="btn btn-outline-secondary" data-bs-dismiss="modal">Close</button>
          <button type="button" v-on:click="confirmDeleteAddressClicked()" class="btn btn-outline-danger">Delete</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import apiConnector from '../../utils/apiConnector';
import showToast from '/src/utils/showToast';
import { Modal } from "bootstrap";
import $ from "jquery";

export default {
  name: 'MerchantCustomerDetails',
  data() {
    return {
      customerDetails: {},
      addresses: [],
      isLoading: true,
      updateAddressId: null,
      addressToDelete: null,
      newAddressName: null,
      newAddressLine1: null,
      newAddressLine2: null,
      newAddressCity: null,
      newAddressState: null,
      newAddressPostalCode: null,
      newAddressCountryCode: 'US',
      newAddressPrimary: 0,
    };
  },
  mounted() {
    this.fetchMerchantCustomerDetails();
  },
  methods: {
    async fetchMerchantCustomerDetails() {
      const customerId = this.$route.params.customer_id;
      try {
        const response = await apiConnector.makeGetRequest(`merchant-customers/${customerId}`);
        if(response && response.data){
          this.customerDetails = response.data.data;
          this.addresses = this.customerDetails.addresses.data;
        }
      } catch (error) {

        console.error('Error fetching merchant customer details:', error);
      }
      finally {
         this.isLoading = false; // Hide the overlay and spinner
      }
    },
    addAddressClicked(){
      this.updateAddressId = null;
      this.newAddressName = null;
      this.newAddressLine1 = null;
      this.newAddressLine2 = null;
      this.newAddressCity = null;
      this.newAddressState = null;
      this.newAddressPostalCode = null;
      this.newAddressCountryCode = 'US';
      this.newAddressPrimary = this.customerDetails.primary_shipping_address ? 0 : 1;
    },
    editAddressClicked(editAddress){
      this.updateAddressId = editAddress.id;
      this.newAddressName = editAddress.name;
      this.newAddressLine1 = editAddress.address_line_1;
      this.newAddressLine2 = editAddress.address_line_2;
      this.newAddressCity = editAddress.city;
      this.newAddressState = editAddress.state_or_region;
      this.newAddressPostalCode = editAddress.postal_code;
      this.newAddressCountryCode = editAddress.country_code;
      this.newAddressPrimary = editAddress.primary ? true : false;
    },
    async createOrUpdateAddress(){
      let payload = this.buildPayload();
      let response = null;
      if(!this.validates()){
        return false;
      }
      try {
        this.isLoading = true;
        if(this.updateAddressId){
          response = await apiConnector.makePatchRequest(`merchant-customers/${this.customerDetails.id}/addresses/${this.updateAddressId}`, payload);
        }else{
          response = await apiConnector.makePostRequest(`merchant-customers/${this.customerDetails.id}/addresses`, payload);
        }
      } catch (error) {

        console.error('Error creating or updating customer address', error);
      }
      finally {
         this.isLoading = false; // Hide the overlay and spinner
      }
      if(response && response.data){
        this.customerDetails = response.data.data;
        this.addresses = this.customerDetails.addresses.data;
        showToast('Address successfully '+(this.updateAddressId ? 'updated.' : 'created.'));
        let modal = Modal.getInstance($('#addOrUpateAddressModal'));
        modal.hide();
      }
    },
    buildPayload(){
      return {
        name: this.newAddressName,
        address_line_1: this.newAddressLine1,
        address_line_2: this.newAddressLine2,
        city: this.newAddressCity,
        state_or_region: this.newAddressState,
        postal_code: this.newAddressPostalCode,
        country_code: this.newAddressCountryCode,
        primary: this.newAddressPrimary ? 1 : 0
      };
    },
    validates(){
      let addressNameValidation = this.validateAddressName();
      let addressLine1Validation = this.validateAddressLine1();
      let addressCityValidation = this.validateAddressCity();
      let addressStateValidation = this.validateAddressState();
      let addressZipValidation = this.validateAddressZip();
      return addressNameValidation && addressLine1Validation && addressCityValidation && addressStateValidation && addressZipValidation;
    },
    validateAddressName(){
      if(!this.newAddressName){
        $('input[name=addressName]').addClass('is-invalid');
        let message = 'Address name is required';
        $('#addressNameError').html(message);
        return false
      }
      $('input[name=addressName]').removeClass('is-invalid');
      $('#addressNameError').html('');
      return true;
    },
    validateAddressLine1(){
      if(!this.newAddressLine1){
        $('input[name=addressLine1]').addClass('is-invalid');
        let message = 'Address line 1 is required';
        $('#addressLine1Error').html(message);
        return false
      }
      $('input[name=addressLine1]').removeClass('is-invalid');
      $('#addressLine1Error').html('');
      return true;
    },
    validateAddressCity(){
      if(!this.newAddressCity){
        $('input[name=addressCity]').addClass('is-invalid');
        let message = 'Address city is required';
        $('#addressCityError').html(message);
        return false
      }
      $('input[name=addressCity]').removeClass('is-invalid');
      $('#addressCityError').html('');
      return true;
    },
    validateAddressState(){
      if(!this.newAddressState){
        $('input[name=addressState]').addClass('is-invalid');
        let message = 'Address state is required';
        $('#addressStateError').html(message);
        return false
      }
      $('input[name=addressState]').removeClass('is-invalid');
      $('#addressStateError').html('');
      return true;
    },
    validateAddressZip(){
      if(!this.newAddressZip){
        $('input[name=addressZip]').addClass('is-invalid');
        let message = 'Address zip code is required';
        $('#addressZipError').html(message);
        return false
      }
      $('input[name=addressZip]').removeClass('is-invalid');
      $('#addressZipError').html('');
      return true;
    },
    deleteAddressClicked(removeAddress){
      this.addressToDelete = removeAddress;
      $('#confirmDeleteModal address').html(removeAddress.name + '<br>' +removeAddress.address_line_1 + '<br>' + (removeAddress.address_line_2 ? removeAddress.address_line_2 + '<br>' : '') + removeAddress.city + ', ' + removeAddress.state_or_region  + ', ' + removeAddress.postal_code + '<br>' + removeAddress.country_code);
    },
    async confirmDeleteAddressClicked(){
      let confirmDeleteModal = Modal.getInstance($('#confirmDeleteModal'));
      if(confirmDeleteModal && this.addressToDelete){
        await apiConnector.makeDeleteRequest(`merchant-customers/${this.customerDetails.id}/addresses/${this.addressToDelete.id}`);
        this.fetchMerchantCustomerDetails();
        showToast('Address successfully deleted.')
        confirmDeleteModal.hide();
      }
    },
    formatDate(dateString) {
      const options = { year: 'numeric', month: 'long', day: 'numeric' };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
};
</script>
